import { forwardRef, MouseEventHandler, ReactNode, Ref, useEffect, useRef } from 'react';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';

// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import CloseIcon from './icons/CloseIconNoBg';
interface Props {
  children: ReactNode;
  show: boolean;
  onClose?: MouseEventHandler<HTMLElement>;
  drawerStyle?: string;
  /** When true, children manage their own scroll (no outer overflow-y). */
  containScroll?: boolean;
}
interface CrossButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
}
const CrossButton = ({
  onClick
}: CrossButtonProps) => <button aria-label="Close" className="-top-4 right-3 z-10 absolute bg-white p-2 rounded-full" onClick={onClick} data-testid="bottom-drawer-close-button" data-sentry-component="CrossButton" data-sentry-source-file="BottomDrawer.tsx">
    <CloseIcon className="fill-transparent stroke-neutral-90 w-4 h-4" data-sentry-element="CloseIcon" data-sentry-source-file="BottomDrawer.tsx" />
  </button>;
const BottomDrawer = forwardRef(({
  children,
  show,
  onClose,
  drawerStyle = '',
  containScroll = false
}: Props, ref: Ref<HTMLDivElement>) => {
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (show) document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [show]);
  useEffect(() => {
    if (show && scrollRef.current && !containScroll) {
      scrollRef.current.scrollTop = 0;
    }
  }, [show, containScroll]);
  return <section className={`${show ? 'opacity-100 visible' : 'opacity-0 invisible'} fixed inset-0 bg-neutral-90/70 z-[60] transition-visibility duration-100`} onClick={e => {
    e.stopPropagation();
    onClose?.(e);
  }} ref={ref} data-testid="bottom-drawer">
        <section className={`absolute w-full bottom-0 md:max-w-md md:bottom-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 trainsition-transform delay-100 duration-300 ${show ? 'translate-y-0 md:-translate-y-1/2' : 'translate-y-full'} ${drawerStyle}`}>
          {onClose ? <CrossButton onClick={() => trackCustomEvent(CustomEventTypes.CROSS_ICON)} /> : null}
          <div ref={scrollRef} className={`w-full max-h-[90vh] overscroll-contain md:rounded-lg ${containScroll ? 'flex flex-col overflow-hidden' : 'overflow-y-auto'}`} onClick={e => e.stopPropagation()}>
            {children}
          </div>
        </section>
      </section>;
});
export default BottomDrawer;